export const SdwanMobileFirst = () => {
    return (
        <div className="relative h-[385px] min-h-[385px] pt-[66px]  [background:linear-gradient(135deg,rgba(235.51,245.26,255,1)_2.885%,rgba(156.92,168.37,255,1)_56.731%,rgba(143.85,201.28,255,1)_97.596%)]">
            <div className="h-[124px]  flex px-[38px] ">
                <div className="flex-1 ">
                    <div className="mt-[7px] justify-start text-[#0182FF] text-[16px] font-medium ">
                        企业出海网络解决方案
                        <br />
                    </div>
                    <div className="justify-start text-[rgba(15,43,91,1)] text-[16px] font-bold mt-[7px]">
                        全球SD-WAN网络加速服务
                    </div>
                    <div className="text-[rgba(51,51,51,1)] text-[10px] font-regular mt-[3px]">跨境电商 海外直播 外贸办公加速 企业全球组网</div>
                    <div className="mt-[10px] flex flex-col gap-[12px]">
                        <a href="https://t22qshgkpd.jiandaoyun.com/f/68cb68e880eabb692970b84a" target="_blank" rel="noreferrer noopener">
                            <div className="w-[84px] h-[28px] flex flex-row justify-center items-center px-[8.29px] py-[3.46px] rounded-[3.32px] [background:linear-gradient(135deg,rgba(94.81,150.87,255,1)_0%,rgba(1,130,255,1)_100%)] text-white text-[8px] font-medium ">立即咨询</div>
                        </a>


                    </div>
                </div>
                <div className="absolute right-[30px] bottom-[50px] pointer-events-none">
                    <img src="/imgs/sdwan/1.png" className="h-[165px] w-[165px] " />

                </div>
            </div>
            <div className="absolute bottom-[-25px] left-0 w-full">
                <div className="flex gap-[5px]  px-[8px] ">
                    <img className="h-[50px] w-full  " src="/imgs/sdwan/2.png" />
                    <img className="h-[50px] w-full  " src="/imgs/sdwan/3.png" />
                    <img className="h-[50px] w-full  " src="/imgs/sdwan/4.png" />
                </div>
            </div>
        </div>
    );
};